<template>
  <div class="crud-register-container">
    <v-container fluid class="crud-register-inner">
      <div class="crud-register-content">
        <v-row class="crud-register-row">
          <v-col
            cols="10"
            style="
              display: flex;
              flex-direction: column;
              overflow: hidden;
              height: 100%;
            "
          >
            <div
              v-if="
                lastBalanceTimestamp && lastBalanceTimestamp !== '' && !showTabs
              "
              style="padding-left: 5%; font-weight: bold"
            >
              Računi izdani nakon {{ lastBalanceTimestamp }}
            </div>
            <!-- Inicijalno stanje: prikazuje se samo lista računa -->
            <div
              v-if="!showTabs"
              style="flex: 1; overflow-y: auto; overflow-x: hidden"
            >
              <Receipts
                ref="generalReceipts"
                style="padding-top: 25px"
                :receiptFilter="receiptFilter"
              ></Receipts>
            </div>

            <!-- Kada se aktiviraju tabovi -->
            <TabManager
              v-else
              ref="tabManager"
              :lastBalanceTimestamp="lastBalanceTimestamp"
              @tabs-empty="onTabsEmpty"
              style="
                flex: 1;
                overflow: hidden;
                display: flex;
                flex-direction: column;
              "
            />
          </v-col>
          <v-col cols="2" style="text-align: center; flex-shrink: 0">
            <table>
              <tbody>
                <tr v-if="teaserVisible">
                  <td>
                    <div class="pos-teaser">
                      <button class="pos-teaser-close" @click="openTeaserDialog('dismiss')">✕</button>
                      <div class="pos-teaser-title">✨ AIKASA SMART POS</div>
                      <div class="pos-teaser-desc">Isprobaj moderniji, brži i pregledniji dizajn kreiran za još lakši svakodnevni rad.</div>
                      <button class="pos-teaser-btn" @click="openTeaserDialog('switch')">Prebaci se na novi izgled</button>
                    </div>
                  </td>
                </tr>
                <tr v-if="teaserVisible"><td>&nbsp;</td></tr>
                <tr>
                  <td>
                    <v-btn
                      id="success"
                      style="width: 100%"
                      class="btn soft-button"
                      @click="openCrudDialog"
                    >
                      Novi račun
                    </v-btn>
                  </td>
                </tr>

                <tr>
                  <td>&nbsp;</td>
                </tr>
                <tr>
                  <td><div class="section-header">PREGLED</div></td>
                </tr>
                <tr>
                  <td>
                    <v-btn
                      id="info"
                      style="width: 100%"
                      class="btn soft-button"
                      @click="openReceipts('receipts')"
                    >
                      Računi i Ponude
                    </v-btn>
                  </td>
                </tr>
                <tr>
                  <td>&nbsp;</td>
                </tr>
                <tr>
                  <td><div class="section-header">BLAGAJNA</div></td>
                </tr>
                <tr>
                  <td>
                    <v-btn
                      id="warning"
                      class="btn warning-button"
                      style="width: 100%"
                      @click="openCloseBalance"
                    >
                      Zaključak
                    </v-btn>
                  </td>
                </tr>
              </tbody>
            </table>
          </v-col>
        </v-row>
      </div>
      <!-- Zadržan stari dialog za kompatibilnost (ako se koristi negdje drugdje) -->
      <crud-template-dialog
        v-if="!showTabs"
        ref="crudTemplateDialog"
      ></crud-template-dialog>
      <close-balance ref="closeBalance"></close-balance>

      <!-- Teaser info modal -->
      <v-dialog v-model="teaserDialog" max-width="420" persistent>
        <v-card style="border-radius:14px; overflow:hidden;">
          <div style="padding:20px 20px 8px; display:flex; align-items:center; gap:10px;">
            <v-icon color="#00BCD4" size="22">mdi-information-outline</v-icon>
            <span style="font-size:15px; font-weight:700; color:#1e293b;">{{ teaserAction === 'switch' ? 'Prebacivanje na Aikasa Smart POS' : 'Promjena izgleda blagajne' }}</span>
          </div>
          <div style="padding:8px 20px 20px; font-size:13px; color:#374151; line-height:1.7;">
            Izgled blagajne možete u svakom trenutku promijeniti klikom na <v-icon size="15" color="#374151" style="vertical-align:middle;">mdi-cog</v-icon> gumb u headeru i odabirom željenog izgleda iz padajućeg izbornika.
          </div>
          <div style="padding:0 16px 16px; display:flex; justify-content:flex-end; gap:8px;">
            <v-btn text @click="teaserDialog = false" style="font-size:13px;">Zatvori</v-btn>
            <v-btn v-if="teaserAction === 'switch'" color="#00BCD4" dark depressed style="font-size:13px; border-radius:8px;" @click="confirmSwitch">Prebaci se</v-btn>
            <v-btn v-else color="#00BCD4" dark depressed style="font-size:13px; border-radius:8px;" @click="teaserDialog = false; dismissTeaser()">Razumijem</v-btn>
          </div>
        </v-card>
      </v-dialog>
    </v-container>
  </div>
</template>
<script>

import CrudTemplateDialog from '@/modules/cash-register/components/dialogs/CrudTemplateDialog'
import Receipts from '@/modules/company/components/receipts/Receipts'
import CloseBalance from '@/modules/cash-register/components/closeBalance/CloseBalance'
import TabManager from '@/modules/cash-register/components/TabManager'
import EventBus from '@/plugins/event-bus'
import state from '@/state'
import { df } from '@/plugins/firebase'

export default {
  components: {
    Receipts,
    CrudTemplateDialog,
    CloseBalance,
    TabManager
  },
  inject: [
  ],
  data: function (vm) {
    return {
      receiptFilter: { oibFilter: undefined, reciptOffer: 'receipts', modal: true, registerId: state.getCashRegister().id, lastBalanceTimestamp: state.getCashRegister().last_balance_timestamp, hideFilter: true },
      teaserVisible: localStorage.getItem(`shop_teaser_dismissed_${state.getCashRegister().id}`) !== '1',
      teaserDialog: false,
      teaserAction: null,
      loadingDialog: false,
      showTabs: false, // Kontrolira prikaz tabova vs. inicijalne liste
      top: true,
      right: true,
      bottom: false,
      left: false,
      transition: 'slide-x-reverse-transition',
      direction: 'bottom',
      fab: true,
      bla: true,
      fling: false,
      hover: false,
      tabs: null,
      buttons: [
        { name: 'Novi račun', action: vm.openCrudDialog },
        { name: '', action: vm.openCrudDialog },
        { name: '', action: vm.openCrudDialog },
        { name: 'Zaključak blagajne', action: vm.openCrudDialog },
        { name: 'Primka', action: vm.openCrudDialog }
      ],
      receiptModal: false,
      vm: vm,
      receiptFilterDialog: {}
    }
  },
  computed: {

    lastBalanceTimestamp () {
      var balanceTimestamp = state.getCashRegister().last_balance_timestamp
      if (balanceTimestamp) {
        return this.$options.filters.local(balanceTimestamp)
      } else {
        return ''
      }
    }

  },

  mounted () {
    // Provjeri ima li spremljenih CRUD tabova u local storage
    const companyId = state.getCurrentCompany().id
    const registerId = state.getCashRegister().id
    const storageKey = `cash-register-tabs-${companyId}-${registerId}`
    const savedTabs = localStorage.getItem(storageKey)

    if (savedTabs) {
      try {
        const data = JSON.parse(savedTabs)
        // Prikaži TabManager samo ako postoje CRUD tabovi (ne računi fiksne tabove)
        if (data.tabs && data.tabs.length > 0) {
          this.showTabs = true
        }
      } catch (error) {
        console.error('Error parsing saved tabs:', error)
      }
    }

    EventBus.$off('stopButtonLoader')
    EventBus.$on('stopButtonLoader', (data) => {
      this.loadingDialog = false
    })

    EventBus.$off('refreshCashRegister')
    EventBus.$on('refreshCashRegister', () => {
      if (this.$refs.generalReceipts) {
        this.$refs.generalReceipts.changeBalanceTimestampFilter(state.getCashRegister().last_balance_timestamp)
      }
    })
  },
  methods: {
    openTeaserDialog (action) {
      this.teaserAction = action
      this.teaserDialog = true
    },
    dismissTeaser () {
      this.teaserVisible = false
      localStorage.setItem(`shop_teaser_dismissed_${state.getCashRegister().id}`, '1')
    },
    async confirmSwitch () {
      this.teaserDialog = false
      await this.switchToSmartPos()
    },
    async switchToSmartPos () {
      this.dismissTeaser()
      try {
        const registerId = state.getCashRegister().id
        await df.doc(`cash_registers/${registerId}`).set({ register_template: 'ai-shop' }, { merge: true })
        state.setRegisterType('ai-shop')
        EventBus.$emit('change-register-template', 'ai-shop')
      } catch (err) {
        console.error('switchToSmartPos: greška pri spremanju', err)
      }
    },
    close () {
      this.receiptModal = false
    },
    closeBalance () {
      if (this.$refs.closeBalance) this.$refs.closeBalance.open()
    },
    openCloseBalance () {
      if (this.$refs.closeBalance) this.$refs.closeBalance.open()
    },
    openCrudDialog () {
      this.showTabs = true // Aktiviraj tab sistem
      this.$nextTick(() => {
        var register = state.getCashRegister()
        var location = state.getPointOfSale()
        this.$refs.tabManager.addNewReceiptTab(register, location)
      })
    },
    openReceipts (receiptOffer) {
      if (receiptOffer === 'receipts') {
        this.showTabs = true // Aktiviraj tab sistem
        this.$nextTick(() => {
          this.$refs.tabManager.openReceiptsTab()
        })
      } else if (receiptOffer === 'offers') {
        this.showTabs = true // Aktiviraj tab sistem
        this.$nextTick(() => {
          this.$refs.tabManager.openOffersTab()
        })
      }
    },

    // Nova metoda: callback kada se zatvore svi tabovi osim "Računi od zaključka"
    onTabsEmpty () {
      this.showTabs = false // Vrati se na inicijalno stanje
    }

  }
}
</script>
<style scoped>
tbody tr:nth-of-type(odd) {
  background-color: rgba(0, 0, 0, 0.15);
}
tr:hover {
  cursor: pointer;
}
td {
  background-color: white;
  padding: 2px;
}

/* Section headers with gradient text */
.section-header {
  font-weight: bold;
  font-size: 14px;
  letter-spacing: 0.5px;
  background: linear-gradient(135deg, #00bcd4 0%, #2196f3 50%, #9c27b0 100%);
  background-clip: text;
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  text-align: center;
  padding: 4px 0;
}

/* Soft button style - white background with blue text and glass effect */
.soft-button {
  background: white !important;
  color: #2196f3 !important;
  border-radius: 12px !important;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.08) !important;
  backdrop-filter: blur(10px);
  -webkit-backdrop-filter: blur(10px);
  border: 1px solid rgba(33, 150, 243, 0.1) !important;
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1) !important;
  font-weight: 500 !important;
  text-transform: none !important;
  letter-spacing: 0.3px !important;
}

.soft-button:hover {
  background: linear-gradient(135deg, rgba(0, 188, 212, 0.05) 0%, rgba(33, 150, 243, 0.05) 50%, rgba(156, 39, 176, 0.05) 100%) !important;
  box-shadow: 0 4px 12px rgba(33, 150, 243, 0.15) !important;
  transform: translateY(-1px);
}

.soft-button:active {
  transform: translateY(0);
  box-shadow: 0 1px 4px rgba(33, 150, 243, 0.2) !important;
}

/* Warning button style - orange gradient */
.warning-button {
  background: linear-gradient(135deg, #ff9800 0%, #ff5722 100%) !important;
  color: white !important;
  border-radius: 12px !important;
  box-shadow: 0 2px 8px rgba(255, 152, 0, 0.25) !important;
  border: none !important;
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1) !important;
  font-weight: 500 !important;
  text-transform: none !important;
  letter-spacing: 0.3px !important;
}

.warning-button:hover {
  background: linear-gradient(135deg, #fb8c00 0%, #f4511e 100%) !important;
  box-shadow: 0 4px 16px rgba(255, 152, 0, 0.35) !important;
  transform: translateY(-1px);
}

.warning-button:active {
  transform: translateY(0);
  box-shadow: 0 1px 4px rgba(255, 152, 0, 0.3) !important;
}
</style>

<style>
::v-deep input::-webkit-outer-spin-button,
::v-deep input::-webkit-inner-spin-button {
  -webkit-appearance: none;
  margin: 0;
}
.new-receipt-fab {
  position: absolute;
  top: 1rem;
  right: 1rem;
}

.categories {
  position: sticky;
  position: -webkit-sticky; /* for Safari */
  top: 64px;
  z-index: 3;
  width: 100%;
}

.categories >>> .v-tabs-bar__content {
  justify-content: center;
  margin-top: 40px;
}

.myTest >>> .vm--modal {
  bottom: 100px !important;
  z-index: 200;
  border-radius: 25px !important;
}

.container {
  background-color: white;
}

.crud-register-container {
  height: calc(100vh - 64px);
  display: flex;
  flex-direction: column;
  overflow: hidden;
}

.crud-register-inner {
  flex: 1;
  display: flex;
  flex-direction: column;
  overflow: hidden;
  padding: 12px !important;
}

.crud-register-content {
  flex: 1;
  display: flex;
  flex-direction: column;
  overflow: hidden;
}

.crud-register-row {
  flex: 1;
  overflow: hidden;
  margin: 0 !important;
}

/* Aikasa Smart POS teaser */
.pos-teaser {
  background: rgba(0,188,212,0.10);
  border: 1.5px solid rgba(0,188,212,0.25);
  border-radius: 14px;
  padding: 12px 12px 10px;
  margin: 0 4px;
  display: flex;
  flex-direction: column;
  gap: 6px;
  position: relative;
}
.pos-teaser-close {
  position: absolute;
  top: 6px; right: 8px;
  background: transparent;
  border: none;
  color: #00838F;
  font-size: 13px;
  cursor: pointer;
  opacity: 0.6;
  line-height: 1;
  padding: 0;
  transition: opacity 0.15s;
}
.pos-teaser-close:hover { opacity: 1; }
.pos-teaser-title {
  font-size: 11px;
  font-weight: 800;
  color: #00838F;
  letter-spacing: 0.5px;
  text-transform: uppercase;
}
.pos-teaser-desc {
  font-size: 12px;
  color: #374151;
  line-height: 1.5;
}
.pos-teaser-btn {
  margin-top: 4px;
  width: calc(100% - 8px);
  margin-left: 4px;
  margin-right: 4px;
  padding: 9px 8px;
  background: #00BCD4;
  color: #ffffff;
  border: none;
  border-radius: 9px;
  font-size: 12px;
  font-weight: 700;
  cursor: pointer;
  transition: background 0.15s;
  box-shadow: 0 2px 8px rgba(0,188,212,0.30);
}
.pos-teaser-btn:hover { background: #0097A7; }
</style>
